let activeContextMenuHandler = null;
export const registerFileContextMenuHandler = (handler) => {
  activeContextMenuHandler = handler;
};
export const showFileContextMenu = (e, items, options = {}) => {
  if (activeContextMenuHandler) {
    activeContextMenuHandler(e, items, options);
  } else {
    console.warn("No file context menu handler registered.");
  }
};
